import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { LSOverviewResponse, LSPathViewResponse } from "./leadershipSeminarAPI.types";

type LeadershipSeminarReqParams = {
  abo: string;
  aff: string;
  locale: string;
  period: string;
  isoCountryCode: string;
  isoCurrencyCode: string;
};

export const lsiAPI = createApi({
  reducerPath: "lsiAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getLsiOverview: builder.query<LSOverviewResponse, LeadershipSeminarReqParams>({
      query: (params) => {
        const { abo, aff, locale, period, isoCountryCode, isoCurrencyCode } = params;
        const queryParams = new URLSearchParams({
          Aff: aff,
          Abo: abo,
          Period: period,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
          Locale: locale,
        });

        return `/incentives-v2/api/lsi/overview?${queryParams}`;
      },
    }),

    getLsiPathViewOverview: builder.query<LSPathViewResponse, LeadershipSeminarReqParams>({
      query: (params) => {
        const { abo, aff, locale, period, isoCountryCode, isoCurrencyCode } = params;
        // Param order mirrors the documented endpoint contract:
        // /incentives-v2/api/lsi/pathview?Aff=&Abo=&Period=&IsoCountryCode=&IsoCurrencyCode=&Locale=
        const queryParams = new URLSearchParams({
          Aff: aff,
          Abo: abo,
          Period: period,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
          Locale: locale,
        });

        return `/incentives-v2/api/lsi/pathview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetLsiOverviewQuery, useGetLsiPathViewOverviewQuery } = lsiAPI;
